import { ChangeDetectionStrategy, Component, InputSignal, ModelSignal, TemplateRef, input, model } from '@angular/core';

import { AbstractVerticalTabGroup } from './abstract-vertical-tab-group';

@Component({
  selector: 'mp-vertical-tab-group',
  templateUrl: './vertical-tab-group.component.html',
  styleUrl: './vertical-tab-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: AbstractVerticalTabGroup, useExisting: VerticalTabGroupComponent }],
})
export class VerticalTabGroupComponent extends AbstractVerticalTabGroup {
  readonly label: InputSignal<string> = input<string>('');
  readonly labelTemplate: InputSignal<TemplateRef<unknown> | undefined> = input<TemplateRef<unknown>>();

  readonly isSelected: ModelSignal<boolean> = model<boolean>(false);

  updateSelectedState(state: boolean): void {
    this.isSelected.set(state);
  }
}
